import dashboardNo from '../resources/no/dashboard.json';
import dashboardSe from '../resources/se/dashboard.json';
import { DashboardLanguageResources } from '../types/DashboardResources';

export const dashboardI18nResources: DashboardLanguageResources = {
  no: { dashboard: dashboardNo },
  se: { dashboard: dashboardSe },
};
